import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  Mail, 
  Phone, 
  Facebook, 
  Instagram, 
  Linkedin, 
  Menu, 
  X, 
  ChevronDown,
  ChevronRight,
  ShoppingBag,
  ExternalLink
} from "lucide-react";
import Logo from "../img/spinoff-logo.png";
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Removed isScrolled logic completely as you don't want it

  const menuItems = [
    {
      title: "About Us",
      path: "/about-us",
      submenu: [
        { label: "Our Team", path: "/our-team" },
        { label: "Our Journey & Infrastructure", path: "/our-journey" },
        { label: "Our Culture", path: "/our-culture" },
      ]
    },
    { title: "Our Customers", path: "/our-customers" },
    {
      title: "Business Verticals",
      submenu: [
        { label: "LED Lights", path: "/our-services/led-lights" },
        { label: "Lithium Battery", path: "/our-services/lithium-battery" },
        { label: "Inverter & UPS", path: "/our-services/inverter-ups" },
        {label: "CCTV", path: "/our-services/cctv" },
      ]
    },
    { title: "Career", path: "https://career.spinoff.in/", external: true },
    { title: "Contact Us", path: "/contact-us" },
  ];

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <div className="nav-wrapper">

      {/* Main Bar */}
      <nav className="main-header">
        <Link to="/" className="nav-logo">
          <img src={Logo} alt="Spinoff Logo" />
        </Link>

        {/* Desktop links */}
        <div className="nav-center">
          {menuItems.map((item, idx) => (
            <div key={idx} className="nav-link-item">
              {item.submenu ? (
                <button 
                  className="nav-link-btn"
                  onClick={() => toggleDropdown(idx)}
                >
                  {item.title} <ChevronDown size={14} />
                </button>
              ) : item.external ? (
                <a href={item.path} target="_blank" rel="noopener noreferrer" className="nav-link-btn">
                  {item.title} <ExternalLink size={14} />
                </a>
              ) : (
                <Link to={item.path} className="nav-link-btn">{item.title}</Link>
              )}

              {item.submenu && (
                <div className={`nav-dropdown ${activeDropdown === idx ? 'show' : ''}`}>
                  <div className="nav-dropdown-content">
                    {item.submenu.map((sub, sIdx) => (
                      <Link key={sIdx} to={sub.path} className="nav-dropdown-link">
                        {sub.label}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Right Side */}
        <div className="nav-right-actions">
           <a href="https://finikelithium.com/shop-online" className="nav-shop-cta">
              Shop Online <ShoppingBag size={18} />
           </a>
           <button className="mobile-menu-btn" onClick={() => setIsMenuOpen(true)}>
             <Menu size={24} />
           </button>
        </div>
      </nav>

      {/* Modern Mobile Sidebar */}
      <div className={`mobile-sidebar ${isMenuOpen ? 'open' : ''}`}>
        <div className="sidebar-backdrop" onClick={closeMenu}></div>
        <div className="sidebar-content">
          <div className="sidebar-header">
            <Link to="/" className="sidebar-logo" onClick={closeMenu}>
              <img src={Logo} alt="Spinoff Logo" />
            </Link>
            <button className="sidebar-close" onClick={closeMenu}>
              <X size={24} />
            </button>
          </div>

          {/* Sidebar Navigation - FIXED */}
          <div className="sidebar-nav">
            {menuItems.map((item, idx) => (
              <div key={idx} className="sidebar-nav-item">
                {item.submenu ? (
                  <>
                    <button 
                      className={`sidebar-nav-link ${activeDropdown === idx ? 'active' : ''}`}
                      onClick={() => toggleDropdown(idx)}
                    >
                      {item.title}
                      <ChevronRight 
                        size={16} 
                        className={`dropdown-arrow ${activeDropdown === idx ? 'rotated' : ''}`}
                      />
                    </button>
                    
                    {/* This was the main issue - now properly controlled */}
                    <div className={`sidebar-dropdown ${activeDropdown === idx ? 'open' : ''}`}>
                      {item.submenu.map((sub, sIdx) => (
                        <Link 
                          key={sIdx} 
                          to={sub.path} 
                          className="sidebar-dropdown-link"
                          onClick={closeMenu}
                        >
                          {sub.label}
                        </Link>
                      ))}
                    </div>
                  </>
                ) : item.external ? (
                  <a 
                    href={item.path} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="sidebar-nav-link"
                    onClick={closeMenu}
                  >
                    {item.title} <ExternalLink size={14} />
                  </a>
                ) : (
                  <Link 
                    to={item.path} 
                    className="sidebar-nav-link"
                    onClick={closeMenu}
                  >
                    {item.title}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* Sidebar Footer */}
          <div className="sidebar-footer">
            <div className="sidebar-contact">
              <div className="contact-item">
                <Mail size={16} />
                <span>sales@spinoff.in</span>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <span>+91 97780-44000</span>
              </div>
            </div>
            <div className="sidebar-social">
              <a href="https://www.facebook.com/SpinoffTechnoparkgroup/" target="_blank" rel="noopener noreferrer"><Facebook size={18} /></a>
              <a href="https://www.instagram.com/spinofftechnopark/" target="_blank" rel="noopener noreferrer"><Instagram size={18} /></a>
              <a href="https://www.linkedin.com/company/spinofftechnopark/" target="_blank" rel="noopener noreferrer"><Linkedin size={18} /></a>
            </div>
            <a href="https://finikelithium.com/shop-online" className="sidebar-shop-btn">
              Shop Online <ShoppingBag size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;